<ng-template #loadingDialogModal let-modal>
  <div class="modal-header text-center" style="display: block;">
    <h4 class="modal-title m-0">Loading</h4>
  </div>
  <div class="modal-body text-center">
    <div class="d-flex justify-content-center">
      <div class="spinner-border" style="width: 3rem; height: 3rem;" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
  </div>
</ng-template>